<mat-card-title class="h5">
	Child IDs
	<mat-icon *ngIf="isLoading">
		<mat-spinner diameter="18"></mat-spinner>
	</mat-icon>
</mat-card-title>
<div *ngFor="let childId of childIdentifiers | studentMsdNumberOnly:msdNumber">
	<div><b>{{childId.STUDENT_IDENTIFIER_TYPES?.TYPE}}:</b> {{childId.IDENTIFIER_VALUE}}
		<app-view-child-ssid-history-btn [studentId]="studentId"
			*ngIf="childId.STUDENT_IDENTIFIER_TYPES?.TYPE === 'SSID Number' && ssidFound"></app-view-child-ssid-history-btn>
	</div>
</div>
<div *ngIf=" !ssidFound"><b>California State Student ID:</b> ---</div>
<div *ngIf="!msdFound"><b>MSDNumber:</b> ---</div>
<div *ngIf="!msixFound"><b>MSIXNumber:</b> ---</div>

<mat-divider class="margin-vertical-sm"></mat-divider>

<mat-card-title class="h5">
	Local SIS IDs
	<mat-icon *ngIf="isLoading">
		<mat-spinner diameter="18"></mat-spinner>
	</mat-icon>
</mat-card-title>
<div *ngFor="let districtID of localIdentifiers | orderBy:'STUDENT_IDENTIFIER_TYPES.TYPE' ">
	<div><b>{{districtID.STUDENT_IDENTIFIER_ORGANIZATIONS[0]?.ORGANIZATION?.NAME}}:</b> {{districtID.IDENTIFIER_VALUE}}
	</div>
</div>
<div class="help-block" *ngIf="localIdentifiers.length <= 0"> This child has no Local SIS IDs.</div>

<mat-divider class="margin-vertical-sm"></mat-divider>

<mat-card-title class="h5">
	COE Star IDs (Legacy)
	<mat-icon *ngIf="isLoading">
		<mat-spinner diameter="18"></mat-spinner>
	</mat-icon>
</mat-card-title>
<div *ngFor="let coeStarID of coeStarIdentifiers | orderBy:'STUDENT_IDENTIFIER_TYPES.TYPE' ">
	<div><b>{{coeStarID.STUDENT_IDENTIFIER_ORGANIZATIONS[0]?.ORGANIZATION.REGIONS[0]?.NAME}}
			({{coeStarID.STUDENT_IDENTIFIER_ORGANIZATIONS[0]?.ORGANIZATION.REGIONS[0]?.CODE}}):</b>
		{{coeStarID.IDENTIFIER_VALUE}}</div>
</div>
<div class="help-block" *ngIf="coeStarIdentifiers.length <= 0"> This child has no COE Star IDs.</div>